import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { useLanguage } from '../../context/LanguageContext'

export default function Breadcrumbs({ items }) {
  const { isRTL } = useLanguage()
  if (!items?.length) return null

  return (
    <nav aria-label="Breadcrumb" className="mb-8 text-sm text-text/60">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, i) => (
          <li key={item.label} className="flex items-center gap-1">
            {i > 0 && (
              <ChevronRight
                className={`h-3.5 w-3.5 text-text/40 ${isRTL ? 'rotate-180' : ''}`}
              />
            )}
            {item.to ? (
              <Link to={item.to} className="hover:text-primary">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-primary">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
